import { useEffect, useState } from "react";
import { fetchUserByIdApi } from "../../../Api/BankStatement";
import { getAllBankApi } from "../../../Api/Bank";

interface Expense {
    url: string;
    Expenses: any[]
}


export const ExpensesAssigned = ({ url, Expenses }: Expense) => {
    const [userNames, setUserNames] = useState<{ [key: string]: string }>({});
    const [bankDetails, setBankDetails] = useState<{
        [key: string]: { name: string; accountNumber: string };
    }>({});

    useEffect(() => {
        const fetchUserNames = async () => {
            const namesMap: { [key: string]: string } = {};
            for (const expense of Expenses) {
                if (
                    expense.from &&
                    !userNames[expense.from] &&
                    !bankDetails[expense.from]
                ) {
                    try {
                        const userData = await fetchUserByIdApi(expense.from);
                        if (userData?.name) {
                            namesMap[expense.from] = userData.name;
                        }
                    } catch (error) {
                        console.error(
                            `Error fetching user name for ID ${expense.from}:`,
                            error
                        );
                    }
                }
            }
            setUserNames((prev) => ({ ...prev, ...namesMap }));
        };

        if (Expenses.length > 0) {
            fetchUserNames();
        }
    }, [Expenses, bankDetails, url]);

    useEffect(() => {
        const fetchBanks = async () => {
            try {
                const bankData = await getAllBankApi(url);
                const bankMap: {
                    [key: string]: { name: string; accountNumber: string };
                } = {};
                bankData.forEach((bank: any) => {
                    bankMap[bank.id] = {
                        name: bank.name,
                        accountNumber: bank.accountNumber,
                    };
                });
                setBankDetails(bankMap);
            } catch (error) {
                console.error("Error fetching banks:", error);
            }
        };
        fetchBanks();
    }, [url]);


    return (

        <div>
            {Expenses.length === 0 ? (
                <div className="text-center py-4 text-gray-500 text-lg">
                    Expenses Or BalanceTransfer Not Assigned
                </div>
            ) : (
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 mt-2">
                    <thead className="bg-gray-50 dark:bg-gray-800">
                        <tr>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>Mode</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>From</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>Type</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>Amount</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                Expense On
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                Description
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                        {Expenses.map((expense: any, index: any) => (
                            <tr className="bg-[#ffff] text-gray-500" key={index}>
                                <td className="px-4 py-4 text-sm font-medium text-gray-500">
                                    {expense.mode}
                                </td>

                                <td className="px-4 py-4 text-sm font-medium  text-gray-500 ">
                                    {userNames[expense.from] ||
                                        (bankDetails[expense.from]
                                            ? `${bankDetails[expense.from].name} - ${bankDetails[expense.from].accountNumber
                                            }`
                                            : "")}
                                </td>
                                <td className="px-4 py-4 text-sm font-medium text-gray-500">
                                    {expense.type}
                                </td>
                                <td className="px-4 py-4 text-sm text-gray-500">
                                    {expense.amount}
                                </td>
                                <td className="px-4 py-4 text-sm text-gray-500">
                                    {new Date(expense.expenseOn).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                    })}
                                </td>
                                <td className="px-4 py-4 text-sm text-gray-500">
                                    {expense.desc}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}


